var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPromiseMenuIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 32,
    viewBox: "0 0 36 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 10.4909C1 5.2489 5.02522 1 9.99124 1C13.4865 1 16.5144 3.10559 18 6.18228C19.4856 3.10559 22.5135 1 26.0088 1C30.9748 1 35 4.98492 35 10.4909C35 20.3055 18 31 18 31C18 31 1 20.3055 1 10.4909Z",
    stroke: "white",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromiseMenuIconWhite);
export default __webpack_public_path__ + "static/media/PromiseMenuIconWhite.56748dc4fc1f33d1e5675de6917f7e00.svg";
export { ForwardRef as ReactComponent };